import { render, staticRenderFns } from "./OrmBatchingView.vue?vue&type=template&id=3eb0c730"
import script from "./OrmBatchingView.vue?vue&type=script&lang=js"
export * from "./OrmBatchingView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3eb0c730')) {
      api.createRecord('3eb0c730', component.options)
    } else {
      api.reload('3eb0c730', component.options)
    }
    module.hot.accept("./OrmBatchingView.vue?vue&type=template&id=3eb0c730", function () {
      api.rerender('3eb0c730', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ormbatching/OrmBatchingView.vue"
export default component.exports